import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BotConfig } from "./utils/botConfig";
import { createI18n } from "vue-i18n";
import axios from "axios";
import EN from "../src/assets/locales/en.json";
import RU from "../src/assets/locales/ru.json";

const messages = {
  EN,
  RU,
};

const savedLanguage = (() => {
  try {
    const raw = localStorage.getItem("vuex");
    return raw ? JSON.parse(raw)?.language : null;
  } catch {
    return null;
  }
})();

const i18n = createI18n({
  locale: savedLanguage || "RU",
  fallbackLocale: "EN",
  legacy: true,
  globalInjection: true,
  messages,
});

axios.interceptors.request.use((config) => {
  const lang = store.getters.getLanguage || "RU";
  config.headers["Accept-Language"] = lang;
  return config;
});

// Сохраняем bot_id до монтирования App (до clearAuth), чтобы пережить reload без query-параметра
BotConfig.getBotId();

const app = createApp(App);
if (window.Telegram && window.Telegram.WebApp) {
  window.Telegram.WebApp.ready();
  app.provide("Telegram", window.Telegram.WebApp);
} else {
  console.warn("Telegram WebApp не доступен.");
}
app.use(store);
app.use(i18n);
app.use(router);
app.mount("#app");
